import * as types from '../../actiontypes';
import Env from '../../../util/env';
import {serviceURL, jsonDocumentPatchOperations} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';

export function getAssociatedClientRequestDocuments(engagementId, clientRequestId) {
	const URLEndpoint = `${Env.getBaseURL(
		serviceURL,
		engagementId
	)}documents?filteredEntityType=clientrequest&documentCategoryName=clientrequestdocument&includeExtension=true&FilteredEntityIdInt=${clientRequestId}&includeClientApprovals=true&pageSize=-1`;

	return {
		type: types.GET_ASSOCIATED_CLIENT_REQUEST_DOCUMENTS,
		meta: {
			api: {
				url: URLEndpoint,
				method: 'GET'
			}
		}
	};
}

export function associateExistingDocument(engagementId, clientRequestId, document) {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}ClientRequests/${clientRequestId}/ClientRequestDocuments`;

	let body = {
		documentId: document.id
	};

	return {
		type: types.ASSOCIATE_EXISTING_DOCUMENT,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: body
			}
		},
		document,
		documentBelongsToCurrentClientRequest: true
	};
}

export function deleteAssociatedDocument(engagementId, clientRequestId, documentId) {
	const url = `${Env.getBaseURL(
		serviceURL,
		engagementId
	)}ClientRequests/${clientRequestId}/ClientRequestDocuments/${documentId}`;

	return {
		type: types.DELETE_ASSOCIATED_DOCUMENT,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		documentId
	};
}

export function markAsDeletedDocument(engagementId, clientRequestId, documentId, value) {
	const url = `${Env.getBaseURL(
		serviceURL,
		engagementId
	)}ClientRequests/${clientRequestId}/ClientRequestDocuments/${documentId}`;
	let data = [Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'IsMarkedAsDeleted', value)];
	return {
		type: types.MARK_AS_DELETED_DOCUMENT,
		meta: {
			api: {
				url,
				method: 'PATCH',
				data: data
			}
		},
		documentId,
		IsMarkedAsDeleted: value
	};
}

export function removeClientRequestDocument(engagementId, clientRequestId, documentId) {
	return {
		type: 'REMOVE_CLIENTREQUEST_DOCUMENT',
		clientRequestId,
		documentId
	};
}

export function getDocumentServiceConfiguration(engagementId) {
	const url = `${Env.getDocServiceUrl('configuration.json')}`;
	return {
		type: 'DOCUMENT_GET_CONFIGURATION',
		meta: {
			api: {
				url,
				method: 'GET',
				headers: {
					EngagementId: engagementId
				}
			}
		}
	};
}

export function updateAnalyticDocumentName(clientRequestDocumentTabId, documentId, documentName) {
	return {
		type: 'UPDATE_ANALYTIC_DOCUMENT_NAME',
		clientRequestDocumentTabId,
		documentId,
		documentName
	};
}
